<template>
  <v-row
    class="
      justify-center
      d-flex
      mx-0
      mt-n16
      bg-white
      position-relative
      border-radius-xl
      shadow
      px-4
    "
  >
    <v-col cols="12" style="max-width: 1400px; margin: 0 auto;">
    <v-container fluid class="py-6">
      <loading-overlay v-if="updating" :text="''" />
      <v-row class="mt-10" v-if="userInformations">
        <v-col cols="auto">
          <v-avatar
            style="cursor: pointer"
            width="74"
            height="74"
            class="shadow border-radius-lg"
            color="bg-gradient-warning"
            @click="$router.push('/profile')"
          >
            <img
              v-if="userInformations && userInformations.avatar"
              :src="getImage(userInformations.avatar)"
              alt="Avatar"
              class="border-radius-lg"
            />
            <div
              v-else-if="
                userInformations &&
                userInformations.firstname &&
                userInformations.lastname
              "
              class="text-white font-weight-bold"
              style="font-size: 24px"
            >
              {{ userInformations.firstname.charAt(0)
              }}{{ userInformations.lastname.charAt(0) }}
            </div>
            <i
              v-else
              class="material-icons-round text-white"
              style="font-size: 40px"
              >person</i
            >
          </v-avatar>
        </v-col>
        <v-col cols="auto" class="my-auto">
          <div class="h-100 pa-3">
            <h5 class="mb-1 text-h5 text-typo font-weight-bold">
              {{
                userInformations && userInformations.firstname
                  ? userInformations.firstname
                  : ""
              }}
              {{
                userInformations && userInformations.lastname
                  ? userInformations.lastname
                  : ""
              }}
            </h5>
            <p class="mb-0 font-weight-light text-body text-sm">
              {{
                userInformations && userInformations.companyName
                  ? userInformations.companyName
                  : ""
              }}
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Header -->
      <v-row class="mt-8 mb-4">
        <v-col cols="12">
          <h3 class="text-h3 text-typo font-weight-bolder">
            Deine Rechnungen
          </h3>
          <p class="text-body font-weight-light text-sm mb-0" style="color: #718096">
            Übersicht über alle deine Rechnungen und Zahlungsvorgänge
          </p>
        </v-col>
      </v-row>

      <!-- Loading State -->
      <v-row v-if="loadingInvoices" class="mt-10">
        <v-col cols="12">
          <v-card
            class="card-shadow border-radius-xl py-16 text-center"
            style="background-color: #f7fafc"
          >
            <div class="mx-auto mb-6">
              <v-progress-circular
                :size="50"
                :width="4"
                color="warning"
                indeterminate
              ></v-progress-circular>
            </div>
            <h4 class="text-h4 text-typo font-weight-bolder mb-4">
              Rechnungen werden geladen...
            </h4>
            <p
              class="text-body font-weight-light px-6"
              style="max-width: 600px; margin: 0 auto; color: #718096"
            >
              Bitte einen Moment Geduld
            </p>
          </v-card>
        </v-col>
      </v-row>

      <!-- Empty State -->
      <v-row v-else-if="invoices.length === 0" class="mt-10">
        <v-col cols="12">
          <v-card
            class="card-shadow border-radius-xl py-16 text-center"
            style="background-color: #f7fafc"
          >
            <div class="mx-auto mb-6">
              <v-avatar
                color="bg-gradient-warning"
                size="100"
                class="shadow"
              >
                <i
                  class="material-icons-round text-white"
                  style="font-size: 50px"
                  >receipt</i
                >
              </v-avatar>
            </div>
            <h4 class="text-h4 text-typo font-weight-bolder mb-4">
              Du hast noch keine Rechnungen
            </h4>
            <p
              class="text-body font-weight-light mb-6 px-6"
              style="max-width: 600px; margin: 0 auto; color: #718096"
            >
              Sobald du Tickets für Events buchst, erscheinen deine Rechnungen
              und Bestellungen hier.
            </p>
            <v-btn
              :elevation="0"
              class="
                font-weight-bold
                text-xs
                btn-default
                bg-gradient-warning
                py-5
                px-8
              "
              color="primary"
              to="/events"
            >
              Events entdecken
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Invoices Table -->
      <v-row v-else>
        <v-col cols="12" class="position-relative">
          <data-table-invoices></data-table-invoices>
        </v-col>
      </v-row>

      
    </v-container>
    </v-col>
  </v-row>
</template>
<script>
import coreData from "@/mixins/coreDataMixin";
import axiosAuth from "@/shared/configs/axios-auth";
import DataTableInvoices from "./Widgets/DatatableInvoices.vue"
export default {
  name: "Profile-Overview",
  mixins: [coreData],
  components: {
    DataTableInvoices,
  },
  data: function () {
    return {
      uploadImageDialog: false,
    };
  },
  computed: {
    userInformations() {
      return this.$store.getters.userInformations;
    },
    invoices() {
      return this.$store.getters.invoices || [];
    },
    loadingInvoices() {
      return this.$store.getters.loadingInvoices;
    },
  },
  mounted() {
    this.$store.dispatch("tryAutoLogin");
    this.$store.dispatch("getInvoicesUser");
  },
  methods: {
    updateUserData() {
      this.$store.dispatch("updateUserInformations", this.userInformations);
      this.SnackbarShow(
        "Success",
        "Aktion erfolgreich!",
        "Profil gespeichert!"
      );
    },
    resetUserData() {
      this.$store.dispatch("userInformations");
    },
    setFile(file) {
      this.userInformations.file = file;
    },
    uploadAvatar() {
      if (!this.userInformations.file) return;
      this.$store.commit("updating", true);
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("image", this.userInformations.file);
        axiosAuth
          .patch("/authnews/me/", formData)
          .then(() => {
            resolve(true);
            this.uploadComplete = true;
            this.$store.commit("updating", false);
            this.$store.dispatch("userInformations");
            this.SnackbarShow(
              "Success",
              "Aktion erfolgreich!",
              "Profil gespeichert!"
            );
            this.uploadImageDialog = false;
          })
          .catch((error) => {
            this.$store.commit("updating", false);
            this.$store.commit("authError", true);
            this.$store.commit("authMessage", error.response.data);
            this.SnackbarShow(
              "Danger",
              "Fehler!",
              "Etwas ist schief gelaufen..."
            );
            reject(error.response.data);
          });
      });
    },
  },
};
</script>
